export default "__VITE_ASSET__DABDv52l__"